import { createClient } from '@supabase/supabase-js'

// Get these from your Supabase project settings
const SUPABASE_URL = 'https://yergxyxcsqvismxjeswk.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inllcmd4eXhjc3F2aXNteGplc3drIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc1NTU1MDUsImV4cCI6MjA3MzEzMTUwNX0.TTtWLnhYuAIwiRlVolQ7R-TXYqjkmKI7auR5j2Egs7o'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
  },
  global: {
    headers: {
      'Content-Type': 'application/json',
    },
  },
})
